import { lang } from "../utilities/lang";
import { useRequestVerificationLink } from "../api/useAuth";
import { useState } from "react";

export const VerfiyBanner = () => {
    const requestVerifyLink = useRequestVerificationLink();
    const [status, setStatus] = useState<string>("");

    return (
        <div className={"verify-banner"}>
            {lang.get(
                "Ihre Email Adresse wurde noch nicht verifiziert. Bitte klicken Sie den Link in der Bestätigungs Email oder fordern Sie eine neue an: "
            )}
            <button
                className={`fly plain ${requestVerifyLink.isPending ? "loading" : ""}`}
                onClick={async () => {
                    const resp = await requestVerifyLink.mutateAsync();
                    if (resp.status === 202) {
                        setStatus(lang.get("Email gesendet"));
                    } else {
                        setStatus(lang.get("Fehler beim versenden der Email. Bitte versuchen sie es später erneut"));
                    }
                }}
            >
                {lang.get("Link anfordern")}
            </button>
            {status ? <div>{status}</div> : null}
        </div>
    );
};
